import { forwardRef } from 'react';
import { Icon } from './icon';
import type { IconProps } from './icon';
import type { Ref } from 'react';
export const MoreVert = forwardRef(function MoreVert(props: IconProps, ref: Ref<SVGSVGElement>) {
  return (
    <Icon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.25 5A2.756 2.756 0 0 1 12 2.25 2.756 2.756 0 0 1 14.75 5 2.756 2.756 0 0 1 12 7.75 2.756 2.756 0 0 1 9.25 5ZM12 3.75c-.686 0-1.25.564-1.25 1.25s.564 1.25 1.25 1.25 1.25-.564 1.25-1.25-.564-1.25-1.25-1.25ZM9.25 12A2.756 2.756 0 0 1 12 9.25 2.756 2.756 0 0 1 14.75 12 2.756 2.756 0 0 1 12 14.75 2.756 2.756 0 0 1 9.25 12ZM12 10.75c-.686 0-1.25.564-1.25 1.25s.564 1.25 1.25 1.25 1.25-.564 1.25-1.25-.564-1.25-1.25-1.25ZM9.25 19A2.756 2.756 0 0 1 12 16.25 2.756 2.756 0 0 1 14.75 19 2.756 2.756 0 0 1 12 21.75 2.756 2.756 0 0 1 9.25 19ZM12 17.75c-.686 0-1.25.564-1.25 1.25s.564 1.25 1.25 1.25 1.25-.564 1.25-1.25-.564-1.25-1.25-1.25Z"
        fill="currentColor"
      />
    </Icon>
  );
});
